import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { DivBackgroundOpacity } from "@utils/extra-style";
import { StatusBadge } from "@modules/ClientUsers/ClientUsersList/ClientUsersList.styled";

const STATUS_ACTIVE = 1;
const STATUS_INACTIVE = 2;
const STATUS_PENDING = 3;

const STATUS_CONFIG = {
  [STATUS_ACTIVE]: { color: "#32a728", label: "USER_STATUS_ACTIVE" },
  [STATUS_INACTIVE]: { color: "#f08046", label: "USER_STATUS_INACTIVE" },
  [STATUS_PENDING]: { color: "#0a4986", label: "USER_STATUS_PENDING" },
};

const Status = (props) => {
  const { t, data } = props;
  const config = STATUS_CONFIG[data.status] || STATUS_CONFIG[STATUS_ACTIVE];

  return (
    <DivBackgroundOpacity opacity={data.status === STATUS_ACTIVE ? "1" : "0.9"}>
      <StatusBadge color={config.color}>{t(config.label)}</StatusBadge>
    </DivBackgroundOpacity>
  );
};

Status.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

export default withTranslation()(Status);
